import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { SegmentedControl } from "../../segmented-control/index.js";
import { ToolbarButton } from "../../toolbar-button/index.js";
import { CloseIcon, CopyIcon } from "../../../icons/index.js";
/* empty css          */
function formatBytes(bytes) {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
const VIEW_OPTIONS = [{
  value: "json",
  label: "JSON"
}, {
  value: "tree",
  label: "Tree"
}, {
  value: "table",
  label: "Table"
}];
const ResponseHeader = ({
  status,
  statusText,
  timeMs,
  sizeBytes,
  upgradeNotice,
  view,
  onViewChange,
  onCopy
}) => {
  const isError = status !== void 0 && (status === 0 || status >= 400);
  const handleDismiss = upgradeNotice == null ? void 0 : upgradeNotice.onDismiss;
  return /* @__PURE__ */ jsxs("header", { className: "graphiql-response-header", children: [
    upgradeNotice ? /* @__PURE__ */ jsxs("span", { className: "graphiql-transport-upgrade-banner", role: "status", children: [
      /* @__PURE__ */ jsx("span", { className: "graphiql-transport-upgrade-banner-dot", "aria-hidden": "true" }),
      /* @__PURE__ */ jsx("span", { className: "graphiql-transport-upgrade-banner-text", children: "Network stats need the Transport API." }),
      /* @__PURE__ */ jsx("a", { className: "graphiql-transport-upgrade-banner-link", href: upgradeNotice.href, target: "_blank", rel: "noopener noreferrer", children: "Learn more" }),
      /* @__PURE__ */ jsx("button", { type: "button", className: "graphiql-transport-upgrade-banner-dismiss", "aria-label": "Dismiss banner", onClick: handleDismiss, children: /* @__PURE__ */ jsx(CloseIcon, { "aria-hidden": "true" }) })
    ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      status !== void 0 && /* @__PURE__ */ jsxs("span", { className: `graphiql-response-status${isError ? " graphiql-response-status--error" : " graphiql-response-status--ok"}`, children: [
        /* @__PURE__ */ jsx("span", { className: "graphiql-response-status-dot", "aria-hidden": "true" }),
        /* @__PURE__ */ jsx("span", { className: "graphiql-response-status-code", children: status === 0 ? "Error" : status }),
        statusText && status !== 0 && /* @__PURE__ */ jsx("span", { className: "graphiql-response-status-text", children: statusText })
      ] }),
      timeMs !== void 0 && /* @__PURE__ */ jsxs("span", { className: "graphiql-response-meta", children: [
        Math.round(timeMs),
        "ms"
      ] }),
      sizeBytes !== void 0 && /* @__PURE__ */ jsx("span", { className: "graphiql-response-meta", children: formatBytes(sizeBytes) })
    ] }),
    /* @__PURE__ */ jsx("span", { className: "graphiql-response-header-spacer" }),
    /* @__PURE__ */ jsx(SegmentedControl, { value: view, onChange: onViewChange, ariaLabel: "Response view", options: VIEW_OPTIONS }),
    onCopy && /* @__PURE__ */ jsx(ToolbarButton, { label: "Copy response", onClick: onCopy, children: /* @__PURE__ */ jsx(CopyIcon, { "aria-hidden": "true" }) })
  ] });
};
export {
  ResponseHeader
};
//# sourceMappingURL=index.js.map
